import React from 'react';

import Icon from './Icon';

const IqosLogoCollapsed = (props) => {
    return (
        <Icon width='43' height='40' {...props}>
            <defs>
                <path id='a' d='M0 0h42.504v40H0z' />
            </defs>
            <g fill='none' fillRule='evenodd'>
                <mask id='b' fill='#fff'>
                    <use xlinkHref='#a' />
                </mask>
                <path
                    d='M21.252 6.95c-4.34 0-8.27 1.759-11.115 4.604a15.67 15.67 0 0 0-4.604 11.115c0 4.34 1.76 8.27 4.604 11.115a15.67 15.67 0 0 0 11.115 4.604c4.34 0 8.27-1.76 11.115-4.604a15.669 15.669 0 0 0 4.604-11.115c0-4.34-1.759-8.27-4.604-11.115A15.67 15.67 0 0 0 21.252 6.95m10.412-.939 4.606 7.978 4.606 7.978c2.313 4.008 2.024 8.516 0 12.022C38.85 37.495 35.09 40 30.464 40H12.04c-4.627 0-8.387-2.505-10.411-6.01-2.025-3.507-2.314-8.015 0-12.023l4.606-7.978 4.606-7.978C13.154 2.004 17.203 0 21.252 0c4.05 0 8.098 2.004 10.412 6.011'
                    fill='#34303D'
                    mask='url(#b)'
                />
            </g>
        </Icon>
    );
};

export default IqosLogoCollapsed;
